import { defineMessages, type MessageDescriptor } from 'react-intl-next';

import { ViewValues } from '@confluence/comments-panel-utils/entry-points/useCommentsPanel';

const i18n = defineMessages({
	unread: {
		id: 'comments-panel.unread.view.label',
		defaultMessage: 'Unread',
		description: 'Label for the unread view menu item',
	},
	open: {
		id: 'comments-panel.open.view.label',
		defaultMessage: 'Open',
		description: 'Label for the open view menu item',
	},
	deletedContent: {
		id: 'comments-panel.deleted-content.view.label',
		defaultMessage: 'Deleted content',
		description: 'Label for the deleted content view menu item',
	},
	resolved: {
		id: 'comments-panel.resolved.view.label',
		defaultMessage: 'Resolved',
		description: 'Label for the resolved view menu item',
	},
});

export type ViewFilter = {
	label: MessageDescriptor;
	name: ViewValues;
};

export const viewOptions: ViewFilter[] = [
	{ label: i18n.open, name: ViewValues.OPEN },
	{ label: i18n.unread, name: ViewValues.UNREAD },
	{ label: i18n.deletedContent, name: ViewValues.DELETED_CONTENT },
	{ label: i18n.resolved, name: ViewValues.RESOLVED },
];

export const getViewOptions = (isNewDanglingCommentExperienceEnabled: boolean): ViewFilter[] => {
	if (!isNewDanglingCommentExperienceEnabled) {
		return viewOptions.filter((viewOption) => viewOption.name !== ViewValues.DELETED_CONTENT);
	}

	return viewOptions;
};
